import React, { Fragment, useEffect, useRef, useState } from "react";
import { getWarehouseKeyValueList } from "../../../services";
import { Toaster, toast } from "react-hot-toast";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { addStockTransfer, getTransferDetails, updateStockTransfer } from "../../../services/Inventory/OtherServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getActiveItemsByFromToWarehouseid, getWarehouseKeyValueDetailsList } from "../../../services/Settings/WarehouseService";
import { Height } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import { storeOptionsByWarehouseId } from "../../../services/Purchase/StoreService";
import { getRackByStore } from "../../../services/Purchase/RackService";
import { getCellByRack, getPalletByCell } from "../../../services/Purchase/CellService";

const StockTransferNew = () => {
    const tempRow = {
        fromWarehouseTitle: "",
        itemId: "",
        itemTitle: "",
        openStockQuantity: 0,
        openStockUnitId: "",
        openStockUnitTitle: "",
        packStockQuantity: 0,
        packStockUnitId: "",
        stockTransferCode: "",
        packStockUnitTitle: "",
        unitName: "",
        closingStockOpenQuantity: 0,
        closingStockBoxQuantity: 0,
        beanStockTransferBatchList: [{
            batchQuantitySelected: 0,
            batchNumber: "",
            batchRate: "",
            batchManufacturingDate: "",
            batchExpiredDate: ""
        }],
        beanBillBatch: []
    };
    const curr = new Date();
    curr.setDate(curr.getDate());
    const [warehouseOptions, setWarehouseOptions] = useState(null);
    const [selectedFromWarehouse, setSelectedFromWarehouse] = useState(null);
    const [selectedToWarehouse, setSelectedToWarehouse] = useState(null);
    const [notes, setNotes] = useState("");
    const [date, setDate] = useState(curr.toISOString().substring(0, 10));
    const [fromWareTitle, setFromWareTitle] = useState();
    const { state } = useLocation();
    const newEdit = state?.newEdit || null;
    const [toItemOptions, setToItemOptions] = useState(null);
    const [toItemMainOptions, setToItemMainOptions] = useState(null);
    const [itemOptions, setItemOptions] = useState(null);
    const [fromItemOptions, setFromItemOptions] = useState(null);
    const [rows, setRows] = useState([{ ...tempRow }]);
    const [loading, setLoading] = useState(false);
    const [itemLoading, setItemLoading] = useState(false);
    let navigate = useNavigate();
    let { id } = useParams();
    const [editFlag, setEditFlag] = useState(id);
    const [subTotal, setSubTotal] = useState(0)
    const [storeOptions, setStoreOptions] = useState(null);
    const [rackOptions, setRackOptions] = useState(null);
    const [cellOptions, setCellOptions] = useState(null);
    const [palleteOptions, setPalleteOptions] = useState(null)
    const [forTrackingAddeddata, setforTrackingAddeddata] = useState()

    useEffect(() => {
        if (rows) {
            const _rows = rows.filter(item => item?.itemId !== "");
            const total = _rows.reduce((acc, item) => {
                const unitConversionValue = parseFloat(item?.unitConversion?.split(':')[1]) || 1;
                const purchasePrice = parseFloat(item?.purchasePriceValue) || 0;
                const closingStockBoxQuantity = parseFloat(item?.closingStockBoxQuantity) || 0;
                const closingStockOpenQuantity = parseFloat(item?.closingStockOpenQuantity) || 0;

                const adjustedPrice = unitConversionValue < 1
                    ? parseFloat((purchasePrice * unitConversionValue).toFixed(2)) || 0
                    : parseFloat((purchasePrice / unitConversionValue).toFixed(2)) || 0;

                return acc + (purchasePrice * closingStockBoxQuantity) + (closingStockOpenQuantity * adjustedPrice);
            }, 0);

            setSubTotal(parseFloat(total).toFixed(2));
        }
    }, [rows]);



    useEffect(() => {
        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWarehouseOptions(options);
                setSelectedFromWarehouse(options[0]);
                setSelectedToWarehouse(options?.[3]);
            } else {
                toast(res);
            }
        });
    }, []);

    useEffect(() => {
        if (selectedToWarehouse, selectedFromWarehouse) {
            if (!editFlag) {
                getWarehouseItems();
            }
        }
    }, [selectedToWarehouse, selectedFromWarehouse]);

    const getWarehouseItems = () => {
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid: selectedFromWarehouse.value,
            uuid2: selectedToWarehouse.value,
        };
        setItemLoading(true);
        getActiveItemsByFromToWarehouseid(data).then((res) => {
            if (res.errorCode === 0) {
                const responseData = res?.responsePacket?.data
                const options = responseData?.map((d) => ({
                    ...d,
                    label: d.itemTitle,
                    value: d.itemId,
                    // label: (
                    //     <div className="selectItemOptions">
                    //         <div className="font-size-14 font-weight-bold">{d.itemTitle}</div>
                    //         <div className={`row font-size-13 ${d.currentStockBoxQuantity <= 0 && d.currentStockOpenQuantity <= 0 ? "text-danger" : ""}`}>
                    //             <div className="col-6">Available Stock:</div>
                    //             <div className="col-3">
                    //                 <span>
                    //                     {d.currentStockBoxQuantity?.toFixed(2)} ({d.packUnitTitle})
                    //                 </span>
                    //             </div>
                    //             <div className="col-3">
                    //                 <span>
                    //                     {d.currentStockOpenQuantity?.toFixed(2)} ({d.unitName})
                    //                 </span>
                    //             </div>
                    //         </div>
                    //         <span className="font-size-13">Rate: {d.sellingPriceValue}</span>
                    //     </div>
                    // ),
                    // label: d.itemTitle
                }));
                const filteredToOptions = options.filter(option => option.warehouseId === selectedToWarehouse.value);
                const filteredFromOptions = options.filter(option => option.warehouseId === selectedFromWarehouse.value);
                setFromItemOptions(filteredFromOptions)
                setToItemOptions(filteredToOptions);
                setToItemMainOptions(filteredToOptions);
                setItemOptions(options);
                setItemLoading(false);
            } else {
                toast(res.message);
            }
        });
    };

    const handleRows = (itemList, toWare, fromWare) => {
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid: fromWare.value,
            uuid2: toWare.value,
        };

        setItemLoading(true);
        getActiveItemsByFromToWarehouseid(data).then((res) => {
            if (res.errorCode === 0) {
                const responseData = res?.responsePacket.data
                const options = responseData?.map((d) => ({
                    ...d,
                    label: d.itemTitle,
                    value: d.itemId,
                    // label: (
                    //     <div className="selectItemOptions">
                    //         <div className="font-size-14 font-weight-bold">{d.itemTitle}</div>
                    //         <div className={`row font-size-13 ${d.currentStockBoxQuantity <= 0 && d.currentStockOpenQuantity <= 0 ? "text-danger" : ""}`}>
                    //             <div className="col-6">Available Stock:</div>
                    //             <div className="col-3">
                    //                 <span>
                    //                     {d.currentStockBoxQuantity?.toFixed(2)} ({d.packUnitTitle})
                    //                 </span>
                    //             </div>
                    //             <div className="col-3">
                    //                 <span>
                    //                     {d.currentStockOpenQuantity?.toFixed(2)} ({d.unitName})
                    //                 </span>
                    //             </div>
                    //         </div>
                    //         <span className="font-size-13">Rate: {d.sellingPriceValue}</span>
                    //     </div>
                    // ),
                    // label: d.itemTitle
                }));
                const filteredToOptions = options.filter(option => option.warehouseId === toWare.value);
                const filteredFromOptions = options.filter(option => option.warehouseId === fromWare.value);
                const _itemList = itemList.map((item) => {
                    const _item = filteredToOptions.find((value) => value.itemId === item.itemId);
                    if (_item) {
                        return {
                            fromWarehouseTitle: toWare.label,
                            itemId: _item.itemId,
                            value: _item.value,
                            itemTitle: _item.itemTitle,
                            label: _item.itemTitle,
                            openStockQuantity: _item?.currentStockOpenQuantity,
                            packStockQuantity: _item.currentStockBoxQuantity,
                            unitName: _item.unitName,
                            openStockUnitId: _item.unitId,
                            packUnitId: _item.packUnitId,
                            packUnitTitle: _item.packUnitTitle,
                            packStockUnitId: _item.packUnitId,
                            closingStockBoxQuantity: item.packStockQuantity,
                            closingStockOpenQuantity: item.openStockQuantity,
                            taxBean: [
                                {
                                    "taxId": "20fa1597-72d5-4902-ae79-e58b20739c88",
                                    "title": "SGST 0.0%",
                                    "rate": 0,
                                    "taxType": "SGST"
                                },
                                {
                                    "taxId": "da1786ba-f1ea-4704-a89a-186b9ec41f27",
                                    "title": "CGST 0.0%",
                                    "rate": 0,
                                    "taxType": "CGST"
                                }
                            ],
                            amount: _item.amount,
                            rate: _item.rate,
                            purchasePriceValue: _item.purchasePriceValue,
                            unitConversion: _item.unitConversion,
                            beanStockTransferBatchList: item.beanStockTransferBatchList.length > 0 ? item.beanStockTransferBatchList : [{
                                batchQuantity: 0,
                                batchNumber: "",
                                batchRate: "",
                                batchManufacturingDate: "",
                                batchExpiredDate: "",
                                batchQuantitySelected: 0
                            }],
                            beanBillBatch: _item?.beanBillBatch
                        }
                    }
                })
                setRows(_itemList)
                var setSend = false;
                var filterOptions = [];
                filteredToOptions &&
                    filteredToOptions?.map((a) => {
                        _itemList &&
                            _itemList?.map((b) => {
                                if (a?.itemId === b?.itemId) {
                                    setSend = true;
                                }
                            });
                        if (!setSend) {
                            filterOptions.push(a);
                        }
                        setSend = false;
                    });
                setToItemOptions(filterOptions);
                setFromItemOptions(filteredFromOptions)
                setToItemOptions(filteredToOptions);
                setToItemMainOptions(filteredToOptions);
                setItemOptions(options);
                setEditFlag(null);
                setItemLoading(false);
            } else {
                toast(res.message);
            }
        });
    }

    useEffect(() => {
        if (id && warehouseOptions) {
            getTransferDetails(id).then((res) => {
                if (res.errorCode === 0) {
                    let d = res.responsePacket;
                    const fromWarehouse = warehouseOptions?.find(option => option.value === d.fromWarehouseId);
                    const toWarehouse = warehouseOptions?.find(option => option.value === d.toWarehouseId);
                    setSelectedFromWarehouse(fromWarehouse)
                    setSelectedToWarehouse(toWarehouse)
                    setNotes(d.note)
                    setDate(d.stockTransferDate);
                    handleRows(d.stockTransferItems, toWarehouse, fromWarehouse);
                    const _data = d.stockTransferItems.map((item) => ({
                        itemId: item.itemId,
                        itemTitle: item.itemTitle,
                        openStockQuantity: item.openStockQuantity,
                        openStockUnitTitle: item.openStockUnitTitle,
                        packStockQuantity: item.packStockQuantity,
                        packStockUnitTitle: item.packStockUnitTitle,
                        amount: item.amount,
                        rate: item.rate,
                        beanStockTransferBatchList: item?.beanStockTransferBatchList?.length > 0 ? item.beanStockTransferBatchList : [{
                            batchQuantity: 0,
                            batchNumber: "",
                            batchRate: "",
                            batchManufacturingDate: "",
                            batchExpiredDate: "",
                            batchQuantitySelected: 0
                        }],
                        beanBillBatch: item?.beanBillBatch

                    }))
                    const data = {
                        fromWarehouseId: fromWarehouse?.value,
                        toWarehouseId: toWarehouse?.value,
                        note: d.note,
                        stockTransferDate: d.stockTransferDate,
                        stockTransferItems: _data,
                        totalAmount: d.totalAmount
                    }
                    setRows(data.stockTransferItems);
                    if (state === "Receipt") {
                        setforTrackingAddeddata(data.stockTransferItems)
                    }
                } else {
                    toast(res.message);
                }
            });
        }

    }, [id, warehouseOptions])
    useEffect(() => {
        if (selectedToWarehouse?.value) {
            storeOptionsByWarehouseId(selectedToWarehouse?.value).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setStoreOptions(options);
                } else {
                    toast.error(res.message)
                }
            });
        }
    }, [selectedToWarehouse]);

    const handleSelectWarehouse = (e, type) => {
        if (type === "from") {
            setSelectedFromWarehouse(e);
        } else {

            setRows([{ ...tempRow }]);
            setSelectedToWarehouse(e);
        }
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].fromWarehouseTitle = selectedToWarehouse.label;
        obj[i].itemId = e.itemId;
        obj[i].value = e.value;
        obj[i].itemTitle = e.itemTitle;
        obj[i].label = e.itemTitle;
        obj[i].openStockQuantity = e?.currentStockOpenQuantity;
        obj[i].packStockQuantity = e?.currentStockBoxQuantity;
        obj[i].unitName = e.unitName;
        obj[i].openStockUnitId = e.unitId;
        obj[i].packUnitId = e.packUnitId;
        obj[i].packUnitTitle = e?.packUnitTitle;
        obj[i].packStockUnitId = e.packUnitId;
        obj[i].purchasePriceValue = e?.purchasePriceValue
        obj[i].unitConversionTitle = e?.unitConversionTitle
        obj[i].unitConversion = e?.unitConversion;
        obj[i].beanBillBatch = e?.beanBillBatch
        obj[i].beanStockTransferBatchList = e?.beanStockTransferBatchList?.length > 0 ? e.beanStockTransferBatchList : [{
            batchQuantity: 0,
            batchNumber: "",
            batchRate: "",
            batchManufacturingDate: "",
            batchExpiredDate: "",
            batchQuantitySelected: 0
        }];
        setRows(obj)
        var setSend = false;
        var filterOptions = [];
        toItemMainOptions &&
            toItemMainOptions?.map((a) => {
                obj &&
                    obj?.map((b) => {
                        if (a.itemId === b.itemId) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setToItemOptions(filterOptions);
    };

    const handleAddRow = () => {
        setRows([...rows, { ...tempRow }]);
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
        var setSend = false;
        var filterOptions = [];
        toItemMainOptions &&
            toItemMainOptions?.map((a) => {
                obj &&
                    obj?.map((b) => {
                        if (a.itemId === b.itemId) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setToItemOptions(filterOptions);
    };

    const handleBoxQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value === "") {
            obj[i].closingStockBoxQuantity = "";
            setRows(obj);
            return;
        }
        let qt = Number(e.target.value);
        obj[i].closingStockBoxQuantity = qt;
        setRows(obj);
    };

    const handleOpenQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value === "") {
            obj[i].closingStockOpenQuantity = "";
            setRows(obj);
            return;
        }
        let qt = Number(e.target.value);
        obj[i].closingStockOpenQuantity = qt;
        setRows(obj);
    };

    const getStaticPackQty = (item) => {
        if (!fromItemOptions) {
            return '0';
        }
        if (fromItemOptions.length <= 0) {
            return '0';
        }
        if (!item) {
            return;
        }
        if (item.itemId === "") {
            return '0';
        }
        const fromItem = fromItemOptions.find((value) => value.itemId === item.itemId);
        let toCurrentStockBoxQuantity = item.packStockQuantity ? item.packStockQuantity : 0;
        let fromCurrentStockBoxQuantity = fromItem?.currentStockBoxQuantity ? fromItem?.currentStockBoxQuantity : 0;
        return `${fromCurrentStockBoxQuantity} ${fromItem?.packUnitTitle} | ${toCurrentStockBoxQuantity} ${item.packUnitTitle}`
    }

    const getStaticLooseQty = (item) => {
        if (!fromItemOptions) {
            return '0';
        }
        if (fromItemOptions.length <= 0) {
            return '0';
        }
        if (!item) {
            return;
        }
        if (item.itemId === "") {
            return '0';
        }
        const fromItem = fromItemOptions.find((value) => value.itemId === item.itemId);
        let toCurrentStockBoxQuantity = item.openStockQuantity ? item.openStockQuantity : 0;
        let fromCurrentStockBoxQuantity = fromItem?.currentStockOpenQuantity ? fromItem?.currentStockOpenQuantity : 0;
        return `${fromCurrentStockBoxQuantity} ${fromItem?.unitName} | ${toCurrentStockBoxQuantity} ${item.unitName}`
    }

    const handleSave = () => {
        if (!selectedFromWarehouse) {
            toast("Select Warehouse");
            return;
        }

        let isInvalid = false;
        rows?.forEach((item) => {
            const invalidBatch = item.beanStockTransferBatchList.some((e) => e.batchNumber === '');

            if (invalidBatch) {
                toast(`Batch Not Found In ${item?.itemTitle}`);
                isInvalid = true;
                return;
            }
        });

        if (isInvalid) {
            return;
        }


        setLoading(true);
        const _data = rows.map((item, i) => ({
            fromWarehouseTitle: selectedFromWarehouse.label,
            isReceived: (state === "Receipt") ? true : false,
            itemId: item.itemId,
            itemTitle: item.itemTitle,
            openStockQuantity: item.closingStockOpenQuantity,
            openStockUnitId: item.openStockUnitId,
            openStockUnitTitle: item.unitName,
            packStockQuantity: item.closingStockBoxQuantity,
            packStockUnitId: item.packUnitId,
            packStockUnitTitle: item.packUnitTitle,
            purchasePriceValue: item.purchasePriceValue,
            amount: (() => {
                const unitConversionValue = parseFloat(item?.unitConversion?.split(':')[1]) || 1;
                const purchasePrice = parseFloat(item?.purchasePriceValue) || 0;
                const closingStockBoxQuantity = parseFloat(item?.closingStockBoxQuantity) || 0;
                const closingStockOpenQuantity = parseFloat(item?.closingStockOpenQuantity) || 0;

                const adjustedPrice = unitConversionValue < 1
                    ? purchasePrice * unitConversionValue
                    : purchasePrice / unitConversionValue;
                return (purchasePrice * closingStockBoxQuantity) + (closingStockOpenQuantity * adjustedPrice) || 0;
            })(),
            taxBean: { "taxId": "4819e09b-9ed1-462e-80ab-4bc8b60a7ba7", "title": "GST 0.0", "rate": 0.0, "amount": 0.0, "taxType": "GST", "isTaxGroup": true, "associatedTax": [{ "taxId": "20fa1597-72d5-4902-ae79-e58b20739c88", "title": "SGST 0.0%", "rate": 0.0, "taxType": "SGST" }, { "taxId": "da1786ba-f1ea-4704-a89a-186b9ec41f27", "title": "CGST 0.0%", "rate": 0.0, "taxType": "CGST" }] },
            rate: (() => {
                const unitConversionValue = parseFloat(item?.unitConversion?.split(':')[1]) || 1;
                const purchasePrice = parseFloat(item?.purchasePriceValue) || 0;

                return item?.closingStockBoxQuantity
                    ? parseFloat(purchasePrice).toFixed(2)
                    : parseFloat((purchasePrice / unitConversionValue).toFixed(2));
            })(),
            beanStockTransferBatchList: item?.beanStockTransferBatchList?.length > 0 ? item.beanStockTransferBatchList : [{
                batchQuantity: 0,
                batchNumber: "",
                batchRate: "",
                batchManufacturingDate: "",
                batchExpiredDate: "",
                batchQuantitySelected: 0
            }],
            batchMultipleDetails: (item?.beanStockTransferBatchList?.length > 0) && (state === "Receipt") && (forTrackingAddeddata && forTrackingAddeddata[i] && forTrackingAddeddata[i]?.beanStockTransferBatchList?.length < item.beanStockTransferBatchList.length) ? JSON.stringify(item.beanStockTransferBatchList) : ""
            ,
            beanBillBatch: item?.beanBillBatch
        }))
        const payload = {
            fromWarehouseId: selectedFromWarehouse.value,
            toWarehouseId: selectedToWarehouse.value,
            note: notes || "",
            stockTransferDate: date || curr.toISOString().substring(0, 10),
            stockTransferItems: _data,
            totalAmount: subTotal,
            isReceived: (state === "Receipt") ? true : false
        };

        if (id) {
            updateStockTransfer(payload, id).then((res) => {
                if (res.errorCode === 0) {
                    toast.success(res.message);
                    navigate("/stockTransfer/list");
                    setLoading(false);
                    setSelectedFromWarehouse(warehouseOptions[0]);
                    setRows([tempRow]);
                } else {
                    toast(res.message);
                    setLoading(false);
                }
            }).catch(error => {
                toast.error("An error occurred while adding stock transfer");
                setLoading(false);
            });
        } else {
            addStockTransfer(payload).then((res) => {
                if (res.errorCode === 0) {
                    toast.success(res.message);
                    navigate("/stockTransfer/list");
                    setLoading(false);
                    setSelectedFromWarehouse(warehouseOptions[0]);
                    setRows([tempRow]);
                } else {
                    toast(res.message);
                    setLoading(false);
                }
            }).catch(error => {
                toast.error("An error occurred while adding stock transfer");
                setLoading(false);
            });
        }
    };
    const handleSubRow = (itemIndex) => {
        const data = rows.map((e, i) => {
            if (i === itemIndex) {
                return {
                    ...e, beanStockTransferBatchList: [...e.beanStockTransferBatchList, {
                        batchQuantity: 0,
                        batchNumber: "",
                        Rate: "",
                        batchManufacturingDate: "",
                        batchExpiredDate: "",
                        batchQuantitySelected: 0
                    }]
                }
            }
            else {
                return e;
            }
        })
        setRows(data)
    }
    const removeSubRows = (i, j) => {
        const data = rows.map((item, ind) => {
            if (ind !== i) {
                return item;
            }
            else {
                return { ...item, beanStockTransferBatchList: item.beanStockTransferBatchList.filter((item2, index2) => index2 !== j) }
            }
        })
        setRows(data)
    }

    const handleSubRowchanges = (i, j, e, name, quantity, batchNumber) => {
        if (name === "batchQuantitySelected" && batchNumber !== "No Batch Found") {
            if (e > quantity) {
                toast.error("Quantity selected is greater than available");
                return;
            }
        }
        const data = rows.map((row, ind) => {
            if (ind === i) {
                return {
                    ...row,
                    beanStockTransferBatchList: row.beanStockTransferBatchList.map((bean, index) => {
                        if (index === j && name === "batchNumber") {
                            return { ...e, batchQuantitySelected: "" }
                        }
                        if (index === j && name === "batchQuantitySelected") {
                            return { ...bean, [name]: e }
                        }
                        return bean;
                    })
                };
            }
            return row;
        });
        setRows(data);
    };
    const handleSelectBeanBatch = async (e, name, i, j) => {
        const _rows = [...rows];


        if (name === "store") {
            const RackOptionsforbatch = await getRackList(e.value)

            const updatedRows = _rows.map((data, ind) => {
                if (ind === i) {
                    const updatedBatchList = data.beanStockTransferBatchList.map((store, index) => {
                        if (index === j) {
                            return { ...store, [`${name}Id`]: e.value, [`${name}Title`]: e.label, rackOptions: RackOptionsforbatch };
                        }
                        return store;
                    });

                    return { ...data, beanStockTransferBatchList: updatedBatchList };
                }
                return data;
            });
            setRows(updatedRows);
        }


        if (name === "rack") {
            let cellOptionsforbatch = await getCellList(e.value)
            const updatedRows = _rows.map((data, ind) => {
                getCellByRack(e.value).then((res) => {
                    const _res = res.responsePacket?.map((item) => ({
                        label: item.value,
                        value: item.key
                    }))
                    cellOptionsforbatch = _res
                })
                if (ind === i) {
                    const updatedBatchList = data.beanStockTransferBatchList.map((store, index) => {
                        if (index === j) {
                            return { ...store, [`${name}Id`]: e.value, [`${name}Title`]: e.label, cellOptions: cellOptionsforbatch };
                        }
                        return store;
                    });

                    return { ...data, beanStockTransferBatchList: updatedBatchList };
                }
                return data;
            });
            setRows(updatedRows)
        }


        if (name === "cell") {
            let palleteOptionsforbatch = await getPalleteOptions(e.value)
            const updatedRows = _rows.map((data, ind) => {
                if (ind === i) {
                    const updatedBatchList = data.beanStockTransferBatchList.map((store, index) => {
                        if (index === j) {
                            return { ...store, [`${name}Id`]: e.value, [`${name}Title`]: e.label, palleteOptions: palleteOptionsforbatch };
                        }
                        return store;
                    });

                    return { ...data, beanStockTransferBatchList: updatedBatchList };
                }
                return data;
            });
            setRows(updatedRows)
        }

        if (name === "pallet") {
            const updatedRows = _rows.map((data, ind) => {
                if (ind === i) {
                    const updatedBatchList = data.beanStockTransferBatchList.map((store, index) => {
                        if (index === j) {
                            return { ...store, [`${name}Id`]: e.value, [`${name}Title`]: e.label };
                        }
                        return store;
                    });
                    return { ...data, beanStockTransferBatchList: updatedBatchList };
                }
                return data;
            });
            setRows(updatedRows)
        }

    }


    const getRackList = async (uuid) => {
        let data = [];
        try {
            let res = await getRackByStore(uuid);
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }));
            data = _res;
        } catch (error) {
            return [];
        }

        return data;
    };



    const getCellList = async (uuid) => {
        let data = []
        try {
            let res = await getCellByRack(uuid)
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }));
            data = _res;
        }
        catch {
            return [];
        }
        return data;
    }

    const getPalleteOptions = async (uuid) => {
        let data = []
        try {
            let res = await getPalletByCell(uuid)
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }));
            data = _res;
        }
        catch {
            return [];
        }
        return data;
    }

    return (
        <>
            <div className="pl-3">
                <h1 className="fill list-header d-flex  align-items-center bg-white p-3 border-bottom">
                    <ReceiptIcon />
                    {!id ? "NEW" : state === "Receipt" ? "RECEIVE" : "EDIT"}&nbsp;
                    STOCK TRANSFER
                </h1>
                <br />
                <div>
                    <div style={{ width: "50%" }}>
                        <div className="d-flex align-items-center pl-3  pb-4 w-100">
                            <div style={{ width: "20%" }} className="mr-4">From Warehouse:</div>
                            <div style={{ width: "50%" }}>
                                <Select
                                    value={selectedFromWarehouse}
                                    id="fromWarehouse"
                                    isDisabled={!warehouseOptions || state === "Receipt" || itemLoading}
                                    options={warehouseOptions}
                                    onChange={(e) => handleSelectWarehouse(e, "from")}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center pl-3 pb-4 w-100">
                            <div style={{ width: "20%" }} className="mr-4"> To Warehouse:</div>
                            <div style={{ width: "50%" }}>
                                <Select
                                    value={selectedToWarehouse}
                                    id="toWarehouse"
                                    isDisabled={!warehouseOptions || state === "Receipt" || itemLoading}
                                    options={warehouseOptions}
                                    onChange={(e) => handleSelectWarehouse(e, "to")}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center pl-3 pb-4 w-100">
                            <div style={{ width: "20%" }} className="mr-4">Date:</div>
                            <div style={{ width: "50%" }}>
                                <input
                                    autoComplete="off"
                                    type="date"
                                    className="form-control"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    style={{ width: "100%" }}
                                    disabled={state === "Receipt"}
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <br />
                <table style={{ width: "100%" }} className="customTable">
                    <tbody>
                        <tr>
                            <td></td>
                            <td>Item</td>
                            <td>Current Pack Qty</td>
                            <td>Rate</td>
                            <td>Transfer Pack Qty</td>
                            <td>Current Loose Qty</td>
                            <td>Rate</td>
                            <td>Transfer Loose Qty</td>
                            <td>Tax</td>
                            <td>Amount</td>
                            <td></td>
                        </tr>
                        {rows && rows?.map((item, itemIndex) => {
                            return <Fragment>
                                <tr key={itemIndex}>

                                    <td>
                                        <div className={itemLoading ? "spinner-loader" : ""}><b>{itemIndex + 1}</b></div>
                                    </td>
                                    <td className="selectMenuItemList" style={{ width: "300px" }}>
                                        <Select
                                            isDisabled={!selectedFromWarehouse || itemLoading}
                                            options={toItemOptions}
                                            value={item}
                                            onChange={(e) => handleItem(e, itemIndex)}
                                            styles={{
                                                option: (provided) => ({
                                                    ...provided,
                                                    padding: '10px 20px',
                                                    height: "40px",
                                                    fontSize: "12px",
                                                    textIndent: '10px',
                                                }),
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <span>
                                            {getStaticPackQty(item)}
                                        </span>
                                    </td>
                                    <td>{parseFloat(item?.purchasePriceValue).toFixed(2) > 0 ? parseFloat(item?.purchasePriceValue).toFixed(2) : 0}</td>
                                    <td>
                                        <input
                                            disabled={!selectedFromWarehouse || itemLoading || item?.closingStockOpenQuantity > 0}
                                            autoComplete="off"
                                            min={0}
                                            type="number"
                                            value={item?.closingStockBoxQuantity}
                                            onChange={(e) => handleBoxQty(e, itemIndex)}
                                        />
                                    </td>
                                    <td>
                                        <span>
                                            {getStaticLooseQty(item)}
                                        </span>
                                    </td>
                                    <td>
                                        {
                                            (() => {
                                                const unitConversionValue = parseFloat(item?.unitConversion?.split(':')[1]) || 0;
                                                const purchasePrice = item?.purchasePriceValue || 0;

                                                return unitConversionValue < 1
                                                    ? parseFloat((purchasePrice * unitConversionValue).toFixed(2)) || 0
                                                    : parseFloat((purchasePrice / unitConversionValue).toFixed(2)) || 0;
                                            })()
                                        }
                                    </td>
                                    <td>
                                        <input
                                            disabled={!selectedFromWarehouse || itemLoading || item?.closingStockBoxQuantity > 0}
                                            autoComplete="off"
                                            min={0}
                                            type="number"
                                            value={item?.closingStockOpenQuantity}
                                            onChange={(e) => handleOpenQty(e, itemIndex)}
                                        />
                                    </td>

                                    <td>0.00</td>
                                    <td>
                                        {
                                            (() => {
                                                const unitConversionValue = parseFloat(item?.unitConversion?.split(':')[1]) || 0;
                                                const purchasePrice = item?.purchasePriceValue || 0;
                                                const closingStockBoxQuantity = item?.closingStockBoxQuantity || 0;
                                                const closingStockOpenQuantity = item?.closingStockOpenQuantity || 0;

                                                const adjustedPrice = unitConversionValue < 1
                                                    ? parseFloat((purchasePrice * unitConversionValue).toFixed(2)) || 0
                                                    : parseFloat((purchasePrice / unitConversionValue).toFixed(2)) || 0;

                                                const totalPrice = purchasePrice * closingStockBoxQuantity + (closingStockOpenQuantity * adjustedPrice);
                                                const roundedPrice = parseFloat(totalPrice.toFixed(2));

                                                return roundedPrice > 0 ? roundedPrice : 0;
                                            })()
                                        }
                                    </td>


                                    <td style={{ cursor: "pointer" }} onClick={() => handleClear(item.itemId, itemIndex)}>
                                        {rows.length > 1 && <i className="fa fa-times" style={{ color: "red" }}></i>}
                                    </td>
                                </tr>
                                <tr style={{ width: "100%" }}>
                                    <td style={{ padding: 0 }} colSpan={16}>
                                        <table style={{ width: "100%", paddingRight: "5px" }} className=" border text-center sub-table">
                                            <thead>
                                                <tr className="border">


                                                    <td> Batch </td>
                                                    <td> Batch Qty</td>
                                                    <td> Qty </td>
                                                    {/* <td> Rate </td> */}
                                                    <td> Mfg </td>
                                                    <td> Expiry </td>
                                                    {state === "Receipt" && <>
                                                        <td>Store</td>
                                                        <td>Rack</td>
                                                        <td>Cell</td>
                                                        <td>Pallete</td></>}
                                                    <td style={{ width: "30px" }}>
                                                        <button
                                                            id="ember1426"
                                                            className="btn btn-default addbtn"
                                                            onClick={() => handleSubRow(itemIndex)}
                                                        >
                                                            <AddIcon
                                                                style={{ color: "blue", }}
                                                            />{" "}
                                                            Add
                                                            More

                                                        </button>
                                                    </td>
                                                </tr>
                                            </thead>
                                            {item?.beanStockTransferBatchList && item?.beanStockTransferBatchList.map((billBatch, j) => {
                                                const allBatchOptions = (
                                                    state !== "Receipt"
                                                        ? [
                                                            {
                                                                value: 'No Batch Found',
                                                                label: 'No Batch Found',
                                                                batchNumber: 'No Batch Found',
                                                                batchQuantity: 0,
                                                                batchManufacturingDate: '1900-01-01',
                                                                batchExpiredDate: '1900-01-01'
                                                            },
                                                            ...(Array.isArray(item?.beanBillBatch) ? item.beanBillBatch : []) // Ensure beanBillBatch is an array
                                                        ].filter(e =>
                                                            !(Array.isArray(item?.beanStockTransferBatchList) &&
                                                                item.beanStockTransferBatchList.find(d => d.batchNumber === e.batchNumber))
                                                        )
                                                        : [
                                                            {
                                                                value: 'No Batch Found',
                                                                label: 'No Batch Found',
                                                                batchNumber: 'No Batch Found',
                                                                batchQuantity: 0,
                                                                batchManufacturingDate: '1900-01-01',
                                                                batchExpiredDate: '1900-01-01'
                                                            },
                                                            ...(Array.isArray(item?.beanBillBatch) ? item.beanBillBatch : []) // Ensure beanBillBatch is an array
                                                        ]
                                                );

                                                const quantityData = item?.beanBillBatch;
                                                const totalSelected = item.beanStockTransferBatchList.reduce((acc, e) => { return acc + parseFloat(e.batchQuantitySelected) }, 0)

                                                return <tbody>
                                                    <tr>
                                                        <td  >
                                                            <Select
                                                                isDisabled={itemLoading}
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minWidth: '180px',
                                                                        fontSize: "13px"
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        minWidth: '180px',
                                                                        fontSize: "13px"
                                                                    }),
                                                                }}
                                                                name="batchNumber"
                                                                onChange={(e) => handleSubRowchanges(itemIndex, j, e, "batchNumber")}
                                                                value={{
                                                                    value: billBatch?.batchNumber,
                                                                    label: billBatch?.batchNumber
                                                                }}
                                                                options={[...(allBatchOptions && allBatchOptions?.length > 0
                                                                    ? allBatchOptions.map(e => ({
                                                                        ...e,
                                                                        value: e.batchNumber,
                                                                        label: e.batchNumber
                                                                    }))
                                                                    : []
                                                                )
                                                                ]}
                                                            />


                                                        </td>
                                                        <td >{quantityData?.find((e) => e.batchNumber === billBatch?.batchNumber)?.batchQuantity}    </td>
                                                        <td>
                                                            <input
                                                                value={billBatch?.batchQuantitySelected}
                                                                type="text"
                                                                name="batchQuantitySelected"
                                                                onChange={(e) => handleSubRowchanges(itemIndex, j, e.target.value, "batchQuantitySelected", billBatch?.batchQuantity, billBatch.batchNumber)}
                                                                isDisabled={itemLoading}
                                                                disabled={!billBatch?.batchNumber || itemLoading}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                value={billBatch?.batchManufacturingDate}
                                                                type="date"
                                                                name="batchManufacturingDate"
                                                                onChange={(e) => handleSubRowchanges(itemIndex, j, e.target.value, "batchManufacturingDate")}
                                                                disabled={true}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                value={billBatch?.batchExpiredDate}
                                                                type="date"
                                                                name="batchExpiredDate"
                                                                onChange={(e) => handleSubRowchanges(itemIndex, j, e.target.value, "batchExpiredDate")}
                                                                disabled={true}
                                                            />
                                                        </td>
                                                        {state === "Receipt" && <>
                                                            <td>
                                                                <Select
                                                                    required
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                    }}
                                                                    value={storeOptions?.find(id => id.value === billBatch?.storeId)}
                                                                    onChange={(e) => handleSelectBeanBatch(e, "store", itemIndex, j)}
                                                                    isDisabled={(!itemLoading) ? false : true} options={storeOptions} placeholder={"Select Store"} />
                                                            </td>
                                                            <td >
                                                                <Select
                                                                    required
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                    }}
                                                                    isDisabled={(!itemLoading && billBatch?.storeId) ? false : true}
                                                                    value={billBatch?.rackOptions && billBatch?.rackOptions?.find(id => id.value === billBatch?.rackId)}
                                                                    onChange={(e) => handleSelectBeanBatch(e, "rack", itemIndex, j)}
                                                                    options={billBatch?.rackOptions} placeholder={"Select Rack"} />
                                                            </td>
                                                            <td>
                                                                <Select
                                                                    required
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                    }}
                                                                    isDisabled={(!itemLoading && billBatch?.rackId) ? false : true}
                                                                    value={billBatch?.cellOptions && billBatch?.cellOptions?.find(id => id.value === billBatch?.cellId)}
                                                                    placeholder={"Select Cell"} onChange={(e) => handleSelectBeanBatch(e, "cell", itemIndex, j)}
                                                                    options={billBatch?.cellOptions} />
                                                            </td>
                                                            <td >
                                                                <Select
                                                                    required
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            minWidth: '100px',
                                                                        }),
                                                                    }}
                                                                    isDisabled={(!itemLoading && billBatch?.cellId) ? false : true}
                                                                    value={billBatch?.palleteOptions?.find(id => id.value === billBatch?.palletId)}
                                                                    options={billBatch?.palleteOptions}
                                                                    placeholder={"Select Pallete"}
                                                                    onChange={(e) => handleSelectBeanBatch(e, "pallet", itemIndex, j)} />
                                                            </td></>}
                                                        <td style={{ width: "30px" }}>
                                                            <button
                                                                className="btn btn-default addbtn"
                                                                onClick={() => removeSubRows(itemIndex, j)}
                                                            >
                                                                X
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            }
                                            )}
                                        </table>
                                    </td>
                                </tr>
                            </Fragment>

                        })}
                    </tbody>
                </table>

                {selectedFromWarehouse && (
                    <>
                        <div>
                            {state !== "Receipt" && <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddRow}>
                                <AddIcon style={{ color: "blue" }} /> New Rows
                            </button>}
                        </div>
                        <br />
                        <div className="d-flex w-100 justify-content-between"  >
                            <div className="col-lg-4">
                                <table className="customTable w-100">
                                    <tr>
                                        <td>Notes:</td>
                                        <td>
                                            <textarea
                                                rows={2}
                                                className="form-control"
                                                name="note"
                                                value={notes}
                                                onChange={(e) => setNotes(e.target.value)}
                                                style={{ height: "50px" }}
                                            /></td>
                                    </tr>
                                </table>
                            </div>

                            <div className="col-lg-4">
                                <table className="customTable w-100">
                                    <tr>
                                        <td>SubTotal:</td>
                                        <td><b>{subTotal > 0 ? subTotal : 0}</b></td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div>
                            {loading ? (
                                <Button variant="contained">
                                    <Spinner />
                                </Button>
                            ) : (
                                <Button disabled={itemLoading} variant="contained" onClick={handleSave}>
                                    {state === "Receipt" ? "Save & Receive" : "Save"}
                                </Button>
                            )}
                        </div>
                    </>
                )}



            </div>
            <Toaster />
        </>
    );
};

export default StockTransferNew;
